<template>
  <span class="text-placeholder" v-if="text">{{text}}</span>
  <span class="text-placeholder" v-else>—</span>
</template>

<script>
export default {
  name: 'text-placeholder',
  props: {
    text: null,
  },
};
</script>



// WEBPACK FOOTER //
// TextPlaceholder.vue?20ee7895